// eslint-disable-next-line no-restricted-imports
import { toast, ToastOptions } from 'react-toastify';

/**
 * Platform-agnostic notification wrapper.
 * 
 * On Web: Wraps react-toastify.
 * On Mobile (Future): Will wrap ToastAndroid or Alert.
 * 
 * Usage:
 * import { notify } from '@/utils/notifications';
 * notify.success('Message');
 */
export const notify = {
  success: (message: string, options?: ToastOptions) => {
    return toast.success(message, options);
  },
  error: (message: string, options?: ToastOptions) => {
    return toast.error(message, options);
  },
  info: (message: string, options?: ToastOptions) => {
    return toast.info(message, options);
  },
  warning: (message: string, options?: ToastOptions) => {
    return toast.warning(message, options);
  },
  // Expose the raw toast object for advanced cases (custom components), 
  // but discourage its use in shared services.
  raw: toast
};
